import moment from 'moment';

const monedaNIO = new Intl.NumberFormat('es-NI', { style: 'currency', currency: 'NIO' });

/** Monto en cordobas. Trata null/undefined como cero para no imprimir "NaN". */
export const importe = (valor) => monedaNIO.format(valor ?? 0);

/** Fecha corta segun el locale activo de moment. */
export const fechaCorta = (valor) => (valor ? moment(valor).format('L') : '');

/** Porcentaje con dos decimales. */
export const porcentaje = (valor) => `${(valor ?? 0).toFixed(2)}%`;
